/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SetDefaultOrganizationSchema
 */
export interface SetDefaultOrganizationSchema {
    /**
     * 
     * @type {number}
     * @memberof SetDefaultOrganizationSchema
     */
    organizationId: number;
}

/**
 * Check if a given object implements the SetDefaultOrganizationSchema interface.
 */
export function instanceOfSetDefaultOrganizationSchema(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "organizationId" in value;

    return isInstance;
}

export function SetDefaultOrganizationSchemaFromJSON(json: any): SetDefaultOrganizationSchema {
    return SetDefaultOrganizationSchemaFromJSONTyped(json, false);
}

export function SetDefaultOrganizationSchemaFromJSONTyped(json: any, ignoreDiscriminator: boolean): SetDefaultOrganizationSchema {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'organizationId': json['organization_id'],
    };
}

export function SetDefaultOrganizationSchemaToJSON(value?: SetDefaultOrganizationSchema | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'organization_id': value.organizationId,
    };
}

